import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .controller('ModalCompleteTaskCtrl', ModalCompleteTaskCtrl);

  ModalCompleteTaskCtrl.$inject = ['$scope', '$uibModalInstance'];

  function ModalCompleteTaskCtrl($scope, $uibModalInstance) {
    $scope.save = function () {
      $uibModalInstance.close({});
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }